import React from 'react'

import { ButtonIcon } from 'common/builder/components/chart/FlowChart/components/Button/ButtonIcon/ButtonIcon'
import { NextStepWrapper } from 'common/builder/components/chart/FlowChart/components/Button/NextStepWrapper/NextStepWrapper'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './ButtonInfo.styles'

interface ButtonInfoProps {
  button: FlowChartButton
}

const ButtonConnectorOffset =
  sharedStyles.Spacings.MEDIUM + sharedStyles.Spacings.NODE_HORIZONTAL_PADDING

export const ButtonInfo = ({ button }: ButtonInfoProps) => {
  return (
    <view style={styles.infoWrapper}>
      <ButtonIcon button={button} style={styles.iconSpriteStyle} />
      {button.nextStep && (
        <NextStepWrapper>
          <NextStep
            nextStep={button.nextStep}
            style={styles.nextStepStyle}
            connectorOffsetX={ButtonConnectorOffset}
          />
        </NextStepWrapper>
      )}
    </view>
  )
}
